import classNames from "classnames";
import { FC } from "react";

type PropTypes = {
  tabs: {
    label: string;
    value: string;
    disabled?: boolean;
    notification?: number;
  }[];
  className?: string;
  value: string;
  onChange: (value: string) => void;
};

const Tabs: FC<PropTypes> = ({ tabs, value, onChange, className }) => {
  return (
    <div className={classNames("tabs", className)}>
      {tabs.map((tab) => (
        <button
          key={tab.value}
          className={classNames("tabs__tab", { "tabs__tab--active": value === tab.value })}
          onClick={() => onChange(tab.value)}
          disabled={tab.disabled}
          type="button"
        >
          <span className={"tabs__tab-label"}>{tab.label}</span>
          {typeof tab.notification === "number" && <span className={"tabs__tab-notification"}>{tab.notification}</span>}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
